import { fallbackFontFamily } from './fonts';
export const fontSizes = [8, 12, 14, 16, 18, 24, 32, 48, 64, 72];
({
    0: fontSizes.micro,
    1: fontSizes.small,
    3: fontSizes.regular,
    5: fontSizes.large,
    6: fontSizes.title3,
    7: fontSizes.title2,
    8: fontSizes.title1,
} = fontSizes);
export const fonts = {
    body: fallbackFontFamily,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9udFNpemVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RoZW1lL2ZvbnRTaXplcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFHN0MsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFrQixDQUFDLENBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBRWhGLENBQUM7SUFDQyxDQUFDLEVBQUUsU0FBUyxDQUFDLEtBQUs7SUFDbEIsQ0FBQyxFQUFFLFNBQVMsQ0FBQyxLQUFLO0lBQ2xCLENBQUMsRUFBRSxTQUFTLENBQUMsT0FBTztJQUNwQixDQUFDLEVBQUUsU0FBUyxDQUFDLEtBQUs7SUFDbEIsQ0FBQyxFQUFFLFNBQVMsQ0FBQyxNQUFNO0lBQ25CLENBQUMsRUFBRSxTQUFTLENBQUMsTUFBTTtJQUNuQixDQUFDLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDcEIsR0FBRyxTQUFTLENBQUMsQ0FBQztBQU1mLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBYztJQUM5QixJQUFJLEVBQUUsa0JBQWtCO0NBQ3pCLENBQUMifQ==